var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-app",attrs:{"id":this.id}},[_c('div',[_c(_vm.currentView,{tag:"component",attrs:{"apiActions":_vm.apiActions,"configTexts":_vm.configTexts,"startingMode":_vm.startingMode,"dynamicType":_vm.dynamicType}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }